import React from "react";
import { Alert, Button } from "@/components/ui";
import { AlertCircle, RefreshCwIcon } from "lucide-react";

interface ErrorStateProps {
  error: string;
  onRetry: () => void;
}

export function ErrorState({ error, onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <Alert variant="destructive" className="max-w-md mb-6 justify-items-start">
        <AlertCircle className="h-4 w-4" />
        <Alert.Title>Error</Alert.Title>
        <Alert.Description>{error}</Alert.Description>
      </Alert>
      <Button onClick={onRetry} variant="outline" className="gap-2">
        <RefreshCwIcon className="h-4 w-4" />
        Retry Loading
      </Button>
    </div>
  );
}
